"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _reactBicycle = require("react-bicycle");
var _reactRouterDom = require("react-router-dom");
var _react = _interopRequireDefault(require("react"));
var _requireAuthentication = _interopRequireDefault(require("../require-authentication"));
var _userIsSystemAdmin = _interopRequireDefault(require("../../schema/security/user-is-system-admin"));
var _link = _interopRequireDefault(require("../core/link"));
var _navTabs = _interopRequireDefault(require("../core/nav-tabs"));
var _clubs = _interopRequireDefault(require("./clubs"));
var _refCodes = _interopRequireDefault(require("./ref-codes"));
var _ageCategories = _interopRequireDefault(require("./age-categories"));
var _classDivisions = _interopRequireDefault(require("./class-divisions"));
var _tiers = _interopRequireDefault(require("./tiers"));
var _defaultRaces = _interopRequireDefault(require("./default-races"));
var _entryTypes = _interopRequireDefault(require("./entry-types"));
var _startListDefaults = _interopRequireDefault(require("./start-list-defaults"));
var _UserMaintenance = _interopRequireDefault(require("./UserMaintenance"));
var _contactOrganisers = _interopRequireDefault(require("./contact-organisers"));
var _SelectionQualifiers = _interopRequireDefault(require("./SelectionQualifiers"));
var _sites = _interopRequireDefault(require("./sites"));
var _counties = _interopRequireDefault(require("./counties"));
var _notFound = _interopRequireDefault(require("../not-found"));
var _fullWidth = _interopRequireDefault(require("../root/full-width"));
var _constantParams = require("../../constant-params");
var _PaddleUkMembership = _interopRequireDefault(require("./PaddleUkMembership"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
var _ref = /*#__PURE__*/_react.default.createElement("p", null, "You do not have access to this page");
var _ref2 = /*#__PURE__*/_react.default.createElement("h1", null, "Settings");
var _ref3 = /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
  component: _notFound.default
});
function Settings({
  isAuthenticated,
  user,
  match: {
    url,
    path
  }
}) {
  if (!(isAuthenticated && (0, _userIsSystemAdmin.default)(user))) return _ref;
  return /*#__PURE__*/_react.default.createElement(_fullWidth.default, null, /*#__PURE__*/_react.default.createElement("div", null, _ref2, /*#__PURE__*/_react.default.createElement(_navTabs.default, null, /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item",
    key: "ref-codes"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-link",
    activeClassName: "active",
    to: url + '/ref-codes'
  }, "Codes")), /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item",
    key: "tiers"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-link",
    activeClassName: "active",
    to: url + '/tiers/year/' + _constantParams.thisYear
  }, "Tiers")), /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item",
    key: "clubs"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-link",
    activeClassName: "active",
    to: url + '/clubs'
  }, "Clubs")), /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item",
    key: "sites"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-link",
    activeClassName: "active",
    to: url + '/sites'
  }, "Sites")), /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item",
    key: "counties"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-link",
    activeClassName: "active",
    to: url + '/counties'
  }, "Counties")), /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item",
    key: "age-categories"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-link",
    activeClassName: "active",
    to: url + '/age-categories'
  }, "Age Categories")), /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item",
    key: "class-divisions"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-link",
    activeClassName: "active",
    to: url + '/class-divisions'
  }, "Class Divisions")), /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item",
    key: "default-races"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-link",
    activeClassName: "active",
    to: url + '/default-races'
  }, "Default Races")), /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item",
    key: "entry-types"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-link",
    activeClassName: "active",
    to: url + '/entry-types'
  }, "Entry Types")), /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item",
    key: "start-list-defaults"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-link",
    activeClassName: "active",
    to: url + '/start-list-defaults'
  }, "Start List Defaults")), /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item",
    key: "UserMaintenance"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-link",
    activeClassName: "active",
    to: url + '/user-maintenance'
  }, "User Maintenance")), /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item",
    key: "paddle-uk-membership"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-link",
    activeClassName: "active",
    to: url + '/paddle-uk-membership'
  }, "Paddle UK Membership")), /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item",
    key: "contact-organisers"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-link",
    activeClassName: "active",
    to: url + '/contact-organisers'
  }, "Contact Organisers")), /*#__PURE__*/_react.default.createElement("li", {
    className: "nav-item",
    key: "selection-qualifiers"
  }, /*#__PURE__*/_react.default.createElement(_link.default, {
    className: "nav-link",
    activeClassName: "active",
    to: url + '/selection-qualifiers'
  }, "Selection Qualifiers"))), /*#__PURE__*/_react.default.createElement("div", {
    style: {
      marginTop: 14
    }
  }, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Switch, null, /*#__PURE__*/_react.default.createElement(_reactRouterDom.Redirect, {
    exact: true,
    from: path,
    to: url + '/ref-codes'
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: false,
    path: path + '/ref-codes',
    component: _refCodes.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/tiers/year/:yearID',
    component: _tiers.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: false,
    path: path + '/clubs',
    component: _clubs.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: false,
    path: path + '/sites',
    component: _sites.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: false,
    path: path + '/counties',
    component: _counties.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/age-categories',
    component: _ageCategories.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/class-divisions',
    component: _classDivisions.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/default-races',
    component: _defaultRaces.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/entry-types',
    component: _entryTypes.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/start-list-defaults',
    component: _startListDefaults.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/user-maintenance',
    component: _UserMaintenance.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/paddle-uk-membership',
    component: _PaddleUkMembership.default
  }), ' ', /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/contact-organisers',
    component: _contactOrganisers.default
  }), /*#__PURE__*/_react.default.createElement(_reactRouterDom.Route, {
    exact: true,
    path: path + '/selection-qualifiers',
    component: _SelectionQualifiers.default
  }), _ref3))));
}
var _default = exports.default = (0, _requireAuthentication.default)((0, _reactBicycle.connect)(Settings));